import styled from '@emotion/styled/macro';
import { BaseButton, Variables } from '@enter/core';
import Icon from '@mdi/react';

export const Wrapper = styled.section`
    width: 100vw;
    height: 100vh;
`;

export const CloseButton = styled(BaseButton)`
    border: 0;
    min-width: 0;
    padding: 0 8px;
    position: absolute;
    top: 10px;
    right: 10px;
`;

export const CloseIcon = styled(Icon)`
    fill: ${Variables.Colors.n30};
`;
